import {
  LayoutDashboard, Shuffle, Smartphone, MousePointerClick,
  Search, TrendingUp, Star,
} from "lucide-react";

export const TABS = [
  { id: "overview",  label: "Vue d'ensemble",    icon: LayoutDashboard },
  { id: "traffic",   label: "Sources de Trafic", icon: Shuffle },
  { id: "devices",   label: "Appareils",         icon: Smartphone },
  { id: "actions",   label: "Actions",           icon: MousePointerClick },
  { id: "keywords",  label: "Mots-clés",         icon: Search },
  { id: "trends",    label: "Tendances",         icon: TrendingUp },
  { id: "reviews",   label: "Avis",              icon: Star },
] as const;

export type TabId = typeof TABS[number]["id"];


export const C = {
  primary:   "#2563eb", 
  secondary: "#3b82f6", 
  accent:    "#ea580c", 

  success:   "#16a34a",
  danger:    "#dc2626",

  muted:     "#94a3b8",

  maps:      "#2563eb",
  search:    "#ea580c",

  desktop:   "#10a6eb",
  mobile:    "#fb923c",
  purple:  "#fa8321",

};
export const DEVICE_COLORS  = [C.desktop, C.mobile];
export const STAR_COLORS    = ["#dc2626", "#ea580c", "#d97706", "#65a30d", "#16a34a"];

export const METRIC_COLORS: Record<string, string> = {
  BUSINESS_IMPRESSIONS_DESKTOP_MAPS:   C.maps,
  BUSINESS_IMPRESSIONS_DESKTOP_SEARCH: C.search,
  BUSINESS_IMPRESSIONS_MOBILE_MAPS:    C.desktop,
  BUSINESS_IMPRESSIONS_MOBILE_SEARCH:  C.mobile,
  CALL_CLICKS:            C.success,
  WEBSITE_CLICKS:         C.primary,
  DIRECTION_REQUESTS:     C.accent,
  BUSINESS_BOOKINGS:      C.secondary,
  BUSINESS_CONVERSATIONS: "#ea580c",
  BUSINESS_FOOD_ORDERS:   "#65a30d",
};

export const METRIC_LABELS: Record<string, string> = {
  BUSINESS_IMPRESSIONS_DESKTOP_MAPS:   "Desktop Maps",
  BUSINESS_IMPRESSIONS_DESKTOP_SEARCH: "Desktop Search",
  BUSINESS_IMPRESSIONS_MOBILE_MAPS:    "Mobile Maps",
  BUSINESS_IMPRESSIONS_MOBILE_SEARCH:  "Mobile Search",
  CALL_CLICKS:            "Appels",
  WEBSITE_CLICKS:         "Clics Site Web",
  DIRECTION_REQUESTS:     "Itinéraires",
  BUSINESS_BOOKINGS:      "Réservations",
  BUSINESS_CONVERSATIONS: "Conversations",
  BUSINESS_FOOD_ORDERS:   "Commandes",
};

export const AXIS = {
  tick: {
    fontSize: 11,
    fill: "#94a3b8",
    fontFamily: "'DM Sans', sans-serif",
  },
};